import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import pegawaiDokumenService from "../../services/pegawaiDokumenService";

export const initialState = {
    loading: false,
    data: [],
}

export const getPegawaiDokumen = createAsyncThunk('pegawaiDokumen/data', async (data) => {
    try {
        const response = await pegawaiDokumenService.data(data)
        return response
    } catch (err) {
        return err.response.data
    }
})

export const storePegawaiDokumen = createAsyncThunk('pegawaiDokumen/store', async (data) => {
    try {
        const response = await pegawaiDokumenService.store(data)
        return response
    } catch (err) {
        return err.response.data
    }
})

export const deletePegawaiDokumen = createAsyncThunk('pegawaiDokumen/delete', async (data) => {
    try {
        const response = await pegawaiDokumenService.delete(data)
        return response
    } catch (err) {
        return err.response.data
    }
})

export const pegawaiDokumenSlice = createSlice({
    name: 'pegawaiDokumen',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPegawaiDokumen.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload?.data ?? []
            })
            .addCase(getPegawaiDokumen.pending, (state) => {
                state.loading = true
            })
            .addCase(getPegawaiDokumen.rejected, (state) => {
                state.loading = false
            })
    },
})

export default pegawaiDokumenSlice.reducer
